import { render, staticRenderFns } from "./Datashake-Logs.vue?vue&type=template&id=2c505162&scoped=true"
import script from "./Datashake-Logs.vue?vue&type=script&lang=js"
export * from "./Datashake-Logs.vue?vue&type=script&lang=js"
import style0 from "./Datashake-Logs.vue?vue&type=style&index=0&id=2c505162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c505162",
  null
  
)

export default component.exports